import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgInfoCircled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.9999 0.935364C4.09837 0.935364 0.935547 4.09819 0.935547 7.99971C0.935547 11.9012 4.09837 15.0641 7.9999 15.0641C11.9014 15.0641 15.0642 11.9012 15.0642 7.99971C15.0642 4.09819 11.9014 0.935364 7.9999 0.935364ZM1.94887 7.99971C1.94887 4.65784 4.65802 1.9487 7.9999 1.9487C11.3418 1.9487 14.0509 4.65784 14.0509 7.99971C14.0509 11.3416 11.3418 14.0508 7.9999 14.0508C4.65802 14.0508 1.94887 11.3416 1.94887 7.99971ZM8.79991 4.8C8.79991 5.24183 8.44174 5.6 7.99992 5.6C7.55809 5.6 7.19991 5.24183 7.19991 4.8C7.19991 4.35817 7.55809 4 7.99992 4C8.44174 4 8.79991 4.35817 8.79991 4.8ZM6.40003 6.4H6.93337H8.00003C8.29459 6.4 8.53337 6.63878 8.53337 6.93334V10.6667H9.0667H9.60003V11.7333H9.0667H8.00003H6.93337H6.40003V10.6667H6.93337H7.4667V7.46667H6.93337H6.40003V6.4Z"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgInfoCircled)
const IconSvgInfoCircled = createIcon(ForwardRef, 'SvgInfoCircled')
export default IconSvgInfoCircled
